import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { getCandidateGoalsWithActivitiesOptions } from 'client/@tanstack/react-query.gen';

const schema = z.object({
  task: z.string().optional(),
});

export type SearchSchema = z.infer<typeof schema>;

export const Route = createFileRoute(
  '/_private/_route/_internal/people/$identityId/_candidate/tasks/goals/$goalId/',
)({
  validateSearch: schema,
  loader: async ({ context }) => {
    const { queryClient } = context;
    await queryClient.ensureQueryData(
      getCandidateGoalsWithActivitiesOptions({
        path: {
          candidate_uuid: context.candidate.uuid,
        },
      }),
    );
  },
});
